import { required, helpers } from 'vuelidate/lib/validators'
const phoneformat = helpers.regex('phoneformat', /^([+])?(([-() ])*(\d+)*)*$/)

export default [{
  "id": "first-name",
  "type": "input",
  "label": "Vorname",
  "size": 50,
  "model": "firstName",
  "validation": {
    required
  },
  "errorMsg": [
    "Geben Sie bitte Ihren Vornamen ein."
  ]
},
{
  "id": "last-name",
  "type": "input",
  "label": "Nachname",
  "size": 50,
  "model": "lastName",
  "validation": {
    required
  },
  "errorMsg": [
    "Geben Sie bitte Ihren Nachnamen ein."
  ]
},
{
  "id": "mobile1",
  "type": "input",
  "label": "Handynummer",
  "size": 50,
  "model": "mobile1",
  "validation": {
    required,
    phoneformat
  },
  "errorMsg": [
    "Geben Sie bitte eine gültige Telefonnummer ein.",
    "Geben Sie bitte eine gültige Telefonnummer ein."
  ]
},
{
  "id": "mobile2",
  "type": "input",
  "label": "Zweite Telefonnummer",
  "size": 50,
  "model": "mobile2",
  "validation": {
    phoneformat
  },
  "errorMsg": [
    "Geben Sie bitte eine gültige Telefonnummer ein."
  ]
},
{
  "id": "address1",
  "type": "input",
  "label": "Adresszeile 1",
  "size": 100,
  "model": "address1",
  "validation": {
    required
  },
  "errorMsg": [
    "Geben Sie bitte Ihre Adresse ein."
  ]
},
{
  "id": "address2",
  "type": "input",
  "label": "Adresszeile 2",
  "size": 100,
  "model": "address2"
},
{
  "id": "city",
  "type": "input",
  "label": "Ort",
  "size": 50,
  "model": "city"
},
{
  "id": "state",
  "type": "input",
  "label": "Bundesland",
  "size": 50,
  "model": "state"
},
{
  "id": "postal-code",
  "type": "input",
  "label": "Postleitzahl",
  "size": 50,
  "model": "postalCode",
  "validation": {
    required
  },
  "errorMsg": [
    "Geben Sie bitte eine gültige Postleitzahl ein."
  ]
},
{
  "id": "country",
  "type": "text",
  "label": "Land / Region",
  "size": 50,
  "model": "countryName"
}
]